import React, { useEffect, useRef, useState } from "react";

// Page-specific pose mascot. Pure pose assets animated with CSS transforms
// (entrances, float, nod, success crossfade). Decorative: no click interactions.
export const PoseEagle = ({
  src,
  successSrc,
  success = false,
  size = 200,
  mobileSize = 110,
  entrance = "none",
  nod = 0,
  className = "",
  testid = "pose-eagle",
}) => {
  const [reduced, setReduced] = useState(false);
  const [nodding, setNodding] = useState(false);
  const nodRef = useRef(nod);
  const timer = useRef(0);

  useEffect(() => {
    setReduced(window.matchMedia("(prefers-reduced-motion: reduce)").matches);
    return () => clearTimeout(timer.current);
  }, []);

  useEffect(() => {
    if (nod === nodRef.current) return;
    nodRef.current = nod;
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    setNodding(false);
    requestAnimationFrame(() => requestAnimationFrame(() => setNodding(true)));
    clearTimeout(timer.current);
    timer.current = setTimeout(() => setNodding(false), 1300);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [nod]);

  const hVars = { "--pe-h": `${size}px`, "--pe-h-m": `${mobileSize}px` };
  const entranceCls = reduced || entrance === "none" ? "" : `pose-entrance-${entrance}`;

  return (
    <div className={`pose-eagle pointer-events-none ${className}`} data-testid={`${testid}-wrap`} aria-hidden="true">
      <div className={entranceCls}>
        <div className={nodding ? "eagle-nod" : ""}>
          <div className={reduced ? "" : "eagle-float"}>
            <span className="relative block">
              <img
                src={src}
                alt=""
                draggable="false"
                data-testid={testid}
                className={`pose-eagle-img select-none transition-opacity duration-500 ${success && successSrc ? "opacity-0" : "opacity-100"}`}
                style={hVars}
              />
              {successSrc && (
                <img
                  src={successSrc}
                  alt=""
                  draggable="false"
                  loading="lazy"
                  decoding="async"
                  data-testid={`${testid}-success`}
                  className={`pose-eagle-img absolute top-0 left-1/2 -translate-x-1/2 max-w-none select-none transition-opacity duration-500 ${success ? "opacity-100" : "opacity-0"}`}
                  style={hVars}
                />
              )}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};
